import { render, staticRenderFns } from "./TimerSimple.vue?vue&type=template&id=08740f94&scoped=true"
import script from "./TimerSimple.vue?vue&type=script&lang=js"
export * from "./TimerSimple.vue?vue&type=script&lang=js"
import style0 from "./TimerSimple.vue?vue&type=style&index=0&id=08740f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08740f94",
  null
  
)

export default component.exports